import React, { useState, useEffect } from 'react';
import { Shield } from 'lucide-react';

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const ls = localStorage.getItem('gynovate_cookie_consent');
    const cookie = document.cookie.split(';').some(c => c.trim().startsWith('gynovate_cookie='));
    if (!ls && !cookie) setVisible(true);
  }, []);

  const handleAccept = () => {
    localStorage.setItem('gynovate_cookie_consent', 'accepted');
    // Set real cookie for 1 year — survives localStorage clears
    const exp = new Date(); exp.setFullYear(exp.getFullYear() + 1);
    document.cookie = `gynovate_cookie=accepted; expires=${exp.toUTCString()}; path=/; SameSite=Strict`;
    setVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem('gynovate_cookie_consent', 'declined');
    const exp = new Date(); exp.setFullYear(exp.getFullYear() + 1);
    document.cookie = `gynovate_cookie=declined; expires=${exp.toUTCString()}; path=/; SameSite=Strict`;
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4" data-testid="cookie-consent">
      <div className="max-w-2xl mx-auto bg-white border border-slate-200 rounded-2xl shadow-2xl px-6 py-4 flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <div className="flex items-start gap-3 flex-1">
          <Shield className="w-5 h-5 text-slate-500 flex-shrink-0 mt-0.5" />
          <div>
            <p className="text-sm text-slate-700">We use essential cookies only for session management. <strong>No patient data is stored.</strong> Sessions auto-delete in 24 hours.</p>
            <a href="/privacy" className="text-xs text-blue-600 hover:underline">Privacy Policy</a>
          </div>
        </div>
        <div className="flex gap-2 flex-shrink-0">
          <button
            onClick={handleDecline}
            className="px-4 py-2 text-xs font-medium text-slate-500 rounded-lg hover:bg-slate-100 transition-colors"
            data-testid="cookie-decline"
          >
            Decline
          </button>
          <button
            onClick={handleAccept}
            className="px-4 py-2 text-xs font-semibold text-white bg-slate-900 rounded-lg hover:bg-slate-800 transition-colors"
            data-testid="cookie-accept"
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
}
